// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bgColorTop[data-v-036210fd]{background-color:#2f3542}.linkStyling[data-v-036210fd]{color:#fff;text-decoration:none;font-size:.875rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
